import { render, staticRenderFns } from "./RejectInfoPopup.vue?vue&type=template&id=21d0054a&scoped=true&"
import script from "./RejectInfoPopup.vue?vue&type=script&lang=js&"
export * from "./RejectInfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./RejectInfoPopup.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RejectInfoPopup.vue?vue&type=style&index=1&id=21d0054a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d0054a",
  null
  
)

export default component.exports